import { Carousel } from '@components/primitives/Carousel'
import { Text } from '@components/primitives/Text'
import { ArticleCard, type ArticleCardProps } from '../ArticleCard'

interface ArticleCardCarouselProps {
  cards: ArticleCardProps[]
  subheading: string
}

/** List of cards based on related articles **/
export function ArticleCardCarousel({
  cards,
  subheading,
}: ArticleCardCarouselProps) {
  return (
    <>
      <Text
        className={'text-neutral900'}
        element='h3'
        styleName='h4'
        value={subheading}
      />

      <Carousel className='gap-4'>
        {cards.map((card, index) => (
          <ArticleCard
            {...card}
            index={index}
            key={`${card.description}-${index}`}
          />
        ))}
      </Carousel>
    </>
  )
}
